<div class="airline-general-information-popup">
  <div class="airline-general-information-popup-header">
    <h1 i18n="@@global.t&cs">T&Cs</h1>
    <svg
      (click)="closeModal()"
      style="cursor: pointer"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.174 15.4505C17.4029 15.6794 17.5316 15.99 17.5316 16.3138C17.5316 16.6375 17.4029 16.9481 17.174 17.177C16.945 17.406 16.6345 17.5346 16.3107 17.5346C15.9869 17.5346 15.6764 17.406 15.4474 17.177L8.99922 10.7268L2.54899 17.175C2.32003 17.404 2.0095 17.5326 1.68571 17.5326C1.36191 17.5326 1.05138 17.404 0.822427 17.175C0.59347 16.946 0.464844 16.6355 0.464844 16.3117C0.464844 15.9879 0.59347 15.6774 0.822427 15.4484L7.27266 9.00024L0.824458 2.55C0.595501 2.32105 0.466875 2.01052 0.466875 1.68672C0.466875 1.36293 0.595501 1.0524 0.824458 0.823442C1.05341 0.594486 1.36395 0.465859 1.68774 0.465859C2.01153 0.465859 2.32206 0.594486 2.55102 0.823442L8.99922 7.27368L15.4495 0.822426C15.6784 0.59347 15.9889 0.464844 16.3127 0.464844C16.6365 0.464844 16.9471 0.59347 17.176 0.822426C17.405 1.05138 17.5336 1.36191 17.5336 1.68571C17.5336 2.0095 17.405 2.32003 17.176 2.54899L10.7258 9.00024L17.174 15.4505Z"
        fill="#1F1F1F"
      />
    </svg>
  </div>
  <div class="airline-general-information-popup-body">
    <div class="airline-general-information-popup-section">
      <h2 i18n="@@compare-rate.general">General</h2>
      <div class="airline-general-information-popup-information">
        <span class="title" i18n="@@airline-general-information.airline"
          >Airline</span
        >
        <span class="value"
          >{{ data.airlineBrand.airlineCompanyCode }}-
          {{ data.airlineBrand.airlineCompanyName }}</span
        >
      </div>
      @if (data.gsaCompany) {
        <div class="airline-general-information-popup-information">
          <span class="title" i18n="@@global.gsa-caps">GSA</span>
          <span class="value">{{ data.gsaCompany?.companyName }}</span>
        </div>
      }
      <div class="airline-general-information-popup-information">
        <span class="title" i18n="@@global.origin">Origin</span>
        <span class="value"
          >{{ data.origin }}- {{ data.originAirportName }}
        </span>
      </div>
      <div class="airline-general-information-popup-information">
        <span class="title" i18n="@@compare-rate.dest">Dest.</span>
        <span class="value"
          >{{ data.destination }}- {{ data.destinationAirportName }}</span
        >
      </div>
      <div class="airline-general-information-popup-information">
        <span class="title" i18n="@@compare-rate.awb-prefix">AWB Prefix</span>
        <span class="value">{{ data.airlineBrand.awbPrefix }}</span>
      </div>
    </div>

    <svg
      width="390"
      height="1"
      viewBox="0 0 400 1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line y1="0.5" x2="380" y2="0.5" stroke="#D6D6D6" />
    </svg>

    <div class="airline-general-information-popup-section">
      <h2 i18n="@@compare-rate.surcharges">Surcharges</h2>
      <div class="airline-general-information-popup-information">
        <span class="title lengthy">
          FSC
          <svg-info-circle matTooltip="Fuel Surcharge"></svg-info-circle>
        </span>
        <span class="value lengthy">
          {{ getFuelSurcharge(data) }}
        </span>
      </div>
      <div class="airline-general-information-popup-information">
        <span class="title lengthy">
          IRC
          <svg-info-circle matTooltip="Insurance Risk Charge"></svg-info-circle>
        </span>
        <span class="value lengthy">
          {{ getSecuritySurcharge(data) }}
        </span>
      </div>
      <div class="airline-general-information-popup-information">
        <span class="title lengthy">
          RFS
          <svg-info-circle matTooltip="Road Feeder Service"></svg-info-circle>
        </span>
        <span class="value lengthy">
          {{ getMiscellaneousSurcharge(data) }}
        </span>
      </div>
      @if (data.rfsRemarks) {
        <div
          class="airline-general-information-popup-information"
          style="margin-top: -8px"
        >
          <span class="title lengthy"></span>
          <span class="value lengthy remarks"> ({{ data.rfsRemarks }}) </span>
        </div>
      }
    </div>

    @if (hasAirlinetaxes || hasGHAtaxes) {
      <div class="airline-general-information-popup-section">
        <svg
          width="390"
          height="1"
          viewBox="0 0 400 1"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line y1="0.5" x2="380" y2="0.5" stroke="#D6D6D6" />
        </svg>
        <h2 i18n="@@compare-rate.taxes">OCDC</h2>
        @if (data.lastUpdatedDate) {
          <div class="airline-general-information-popup-information">
            <span class="lengthy" i18n="@@compare-rate.ocdc-last-updated"
              ><small
                ><i
                  >Last updated
                  {{ data.taxes.lastUpdatedDate | time: "DD MMM yyyy" }}</i
                ></small
              ></span
            >
          </div>
        }
        @if (hasAirlinetaxes) {
          <h3 i18n="@@compare-rate.airline-taxes">Airlines</h3>
          @if (data.taxes?.ams?.length > 0) {
            <div class="airline-general-information-popup-information">
              <span class="title lengthy">
                AMS
                <svg-info-circle
                  matTooltip="Automated Manifest System"
                ></svg-info-circle>
              </span>
              <span class="value lengthy">{{ data.taxes.ams }} </span>
            </div>
          }
          @if (data.taxes?.cca?.length > 0) {
            <div class="airline-general-information-popup-information">
              <span class="title lengthy">
                CCA
                <svg-info-circle
                  matTooltip="Cargo Correction Advise"
                ></svg-info-circle>
              </span>
              <span class="value lengthy">{{ data.taxes.cca }} </span>
            </div>
          }
          @if (data.taxes?.chc?.length > 0) {
            <div class="airline-general-information-popup-information">
              <span class="title lengthy">
                CHC
                <svg-info-circle
                  matTooltip="Consolidated House Consignment"
                ></svg-info-circle>
              </span>
              <span class="value lengthy">{{ data.taxes.chc }} </span>
            </div>
          }
          @if (data.taxes?.ecs?.length > 0) {
            <div class="airline-general-information-popup-information">
              <span class="title lengthy">
                ECS
                <svg-info-circle
                  matTooltip="Export Control System"
                ></svg-info-circle>
              </span>
              <span class="value lengthy">{{ data.taxes.ecs }} </span>
            </div>
          }
          @if (data.taxes?.fhl?.length > 0) {
            <div class="airline-general-information-popup-information">
              <span class="title lengthy">
                FHL
                <svg-info-circle
                  matTooltip="Freight House List"
                ></svg-info-circle>
              </span>
              <span class="value lengthy">{{ data.taxes.fhl }} </span>
            </div>
          }
          @if (data.taxes?.fwb?.length > 0) {
            <div class="airline-general-information-popup-information">
              <span class="title lengthy">
                FWB
                <svg-info-circle matTooltip="Freight Waybill"></svg-info-circle>
              </span>
              <span class="value lengthy">{{ data.taxes.fwb }} </span>
            </div>
          }
          @if (data.taxes?.pod?.length > 0) {
            <div class="airline-general-information-popup-information">
              <span class="title lengthy">
                POD
                <svg-info-circle
                  matTooltip="Proof of Delivery"
                ></svg-info-circle>
              </span>
              <span class="value lengthy">{{ data.taxes.pod }} </span>
            </div>
          }
          @if (data.taxes?.rac?.length > 0) {
            <div class="airline-general-information-popup-information">
              <span class="title lengthy">
                RAC
                <svg-info-circle
                  matTooltip="Règlementation Aérienne Cargo"
                ></svg-info-circle>
              </span>
              <span class="value lengthy">{{ data.taxes.rac }} </span>
            </div>
          }
          @if (data.taxes?.saf?.length > 0) {
            <div class="airline-general-information-popup-information">
              <span class="title lengthy">
                SAF
                <svg-info-circle
                  matTooltip="Sustainable Aviation Fuel"
                ></svg-info-circle>
              </span>
              <span class="value lengthy">{{ data.taxes.saf }} </span>
            </div>
          }
        }
        @if (hasGHAtaxes) {
          <h3 style="margin-top: 10px" i18n="@@compare-rate.gha-taxes">GHA</h3>
          @if (data.taxes?.dfc?.length > 0) {
            <div class="airline-general-information-popup-information">
              <span class="title lengthy">
                DFC
                <svg-info-circle
                  matTooltip="Document Fee Charge"
                ></svg-info-circle>
              </span>
              <span class="value lengthy">{{ data.taxes.dfc }} </span>
            </div>
          }
          @if (data.taxes?.scc?.length > 0) {
            <div class="airline-general-information-popup-information">
              <span class="title lengthy">SCC</span>
              <span class="value lengthy">{{ data.taxes.scc }} </span>
            </div>
          }
        }
        @if (hasOtherOCDCtaxes) {
          <h3 style="margin-top: 10px" i18n="@@compare-rate.other-ocdc-taxes">
            Other OCDC
          </h3>
          <div class="airline-general-information-popup-information">
            <span class="other">{{ data.taxes.otherOcdc }} </span>
          </div>
        }
      </div>
    }
  </div>
</div>
